import { render, staticRenderFns } from "./deviceinspecttask.vue?vue&type=template&id=4c651c5d&"
import script from "./deviceinspecttask.vue?vue&type=script&lang=js&"
export * from "./deviceinspecttask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports